import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faArrowRight} from "@fortawesome/free-solid-svg-icons";
import { NavLink } from "reactstrap";
const solutions = [
  {
    title: "Credit Assessment",
    image:
      `${process.env.REACT_APP_CDN_URL}/assets/images/public-home/solutions/credit_assessment.svg`,
    description:
      "Automate credit underwriting processes and lend with confidence.",
    link: "Know More ",
    url: `https://about.crediwatch.com/product/enhanced-credit-reports/`
  },
  {
    title: "Business Monitoring",
    image:
      `${process.env.REACT_APP_CDN_URL}/assets/images/public-home/solutions/business_monitoring.svg`,
    description:
      "Monitor business health across multiple dimensions and prempt risks.",
    link: "Know More ",
    url: `https://about.crediwatch.com/product/early-warning-systems/`
  },
  {
    title: "Customer Discovery",
    image:
      `${process.env.REACT_APP_CDN_URL}/assets/images/public-home/solutions/customer_discovery.svg`,
    description:
      "Discover newer business opportunities and grow with the right set of customers.",
    link: "Book a Demo ",
    url: `https://about.crediwatch.com/contact/request-a-demo/`
  },
];

const Solutions = () => {
  return (
    <>
      <div className="d-flex flex-column justify-content-center pb-4">
      <h1 className='title mb-4 ff-renner-bold text-center'>
        Crediwatch Solutions
      </h1>
      <div className='line text-primary bg-primary align-self-center' />
      </div>
      
      <div className='row justify-content-center '>
        {solutions.map((solution, index) => {
          return (
            <>
              <div className="card col-lg-3 col-md-4 m-2" key={index} style={{ backgroundColor: '#D9DFEA' }}>
                <h5 className="mt-3 text-center font-weight-bold h4 mb-3 px-2 ff-renner-book">
                  {solution.title}
                </h5>
                <div className="card-body pt-0">
                  <img
                    className="card-img-top rounded mb-2 bg-white"
                    src={solution.image}
                    alt="Card image cap"
                  />
                  <p className="card-text h6 lh mt-4 ff-renner-book">
                    {solution.description}
                  </p>
                  <NavLink href={`${solution.url}`}  className="h6 p-0 text-primary mt-3 ff-renner-book">
                    {solution.link}
                    <FontAwesomeIcon icon={faArrowRight}/>
                  </NavLink>
                </div>
              </div>
            </>
          );
        })}
      </div>
    </>
  );
};

export default Solutions;
